import React, { Component } from 'react';
import _ from 'lodash';
import './AutoCampaigns.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../../components/Header';
import campaignTable from '../../tables/autoCampaigns';
import Table from '../../components/Table';
import ConfirmationModal from '../../components/ConfirmationModal';
import Modal from '../../components/Modal';
import formHelpers from '../../helpers/FormHelpers';
import Guide from '../../components/Guide';
import Step from '../../components/Step';
import Button from '../../components/Button';
import phase1Fields from '../../forms/autoCampaign/autoCampaignPhase1';
import phase2Fields from '../../forms/autoCampaign/autoCampaignPhase2';
import phase2FieldsBirthday from '../../forms/autoCampaign/autoCampaignPhase2Birthday';
import phase2FieldsLost from '../../forms/autoCampaign/autoCampaignPhase2Lost';
import phase3Fields from '../../forms/campaign/createAutoPhase3';
import phase4Fields from '../../forms/campaign/createPhase4';
import promotionHelpers from '../../helpers/promotions/buildValues';
import campaignHelpers from '../../helpers/campaign/buildValues';
import { validatePhases, checkForErrors } from '../../helpers/Validation';
import { extractPhasesOrFail } from '../../helpers/ValueBuilder';
import CampaignInfo from '../../helpers/AutoCampaignInfo';
import campaignActions from '../../actions/campaign';
import modalActions from '../../actions/modal';
import populateForm from '../../helpers/PopulateForm';
import promotionActions from '../../actions/promotion';
import phaseHelpers from '../../helpers/PhaseHelpers';


class AutoCampaigns extends Component {
	constructor() {
		super();
		this.handleModalToggle = this.handleModalToggle.bind(this);
    this.handleNewClick = this.handleNewClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleSelectFieldChange = this.handleSelectFieldChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.performCreateOrUpdate = this.performCreateOrUpdate.bind(this);
    this.handleSelectClick = this.handleSelectClick.bind(this);
    this.handleFieldFocus = this.handleFieldFocus.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleMultiSelectClick = this.handleMultiSelectClick.bind(this);
    this.handleModalCloseClick = this.handleModalCloseClick.bind(this);
		this.handleEditClick = this.handleEditClick.bind(this);
		this.resetCampaign = this.resetCampaign.bind(this);
		this.handleRowPreCheck = this.handleRowPreCheck.bind(this);
	}

	componentWillMount() {
    const { location, dispatch, vendor } = this.props;
    if (vendor.selected && vendor.selected.apikey &&
      location.selected && location.selected.apikey) {
      dispatch(campaignActions.list(vendor.selected.apikey, location.selected.apikey));
    }

    this.setState({
      activeSection: '1',
      currentPhase: 'phase1Fields',
      buttonText: 'Next',
      phase1Fields,
			phase2Fields: {},
      phase3Fields,
      phase4Fields,
			updateField: false,
			modalInfo: CampaignInfo,
			modalFooterMessage: null
    })
	}

	resetCampaign() {
    const { phase1Fields, phase2Fields, phase3Fields, phase4Fields } = this.state;
		const { location } = this.props;
    this.setState({
      updateField: false,
      phase1Fields,
    	phase2Fields: {},
      phase3Fields,
      phase4Fields
    })
	}

  performCreateOrUpdate(currentPhase) {
    const { phase1Fields, phase2Fields, phase3Fields, phase4Fields, updateField } = this.state;
		const { dispatch, vendor, location } = this.props;
    let campaignData = extractPhasesOrFail({ phase1Fields, phase2Fields });
    let promotionData = extractPhasesOrFail({ phase3Fields });

    if (campaignData && promotionData && updateField) {
    	dispatch(campaignActions.update(
				campaignHelpers.prepRecurringForPush(campaignData),
				promotionHelpers.prepCampaignForPush(promotionData),
				vendor.selected.apikey,
				location.selected.apikey,
				updateField.apikey,
				updateField.promotion_apikey
			));
			this.resetCampaign();
		} else if (campaignData && promotionData) {
    	dispatch(campaignActions.create(
				campaignHelpers.prepRecurringForPush(campaignData),
				promotionHelpers.prepCampaignForPush(promotionData),
				vendor.selected.apikey,
				location.selected.apikey
			));
			this.resetCampaign();
    } else {
      new Promise((resolve, reject) => {
        this.setState({
          [currentPhase]: formHelpers.blurphase(this.state[currentPhase])
        })
        resolve();
      }).then(() => {
        if (checkForErrors(this.state[currentPhase]) === false) {
          if (nextSection === '4') buttonNext = 'Finish';
          this.setState({
            activeSection: nextSection,
            buttonText: buttonNext,
            currentPhase: nextPhase
          })
        } else {
          this.setState({
            [currentPhase]: validatePhases(this.state[currentPhase])
          })
        }
      })
    }
  }

	handleNextClick() {
		const { activeSection, currentPhase } = this.state;
	  phaseHelpers.handleNextClick(activeSection, currentPhase, '5', this);
  }

	handleSelectFieldChange(option, name) {
		if (name === 'recurring_type' && option.value === 'lost-customers') {
			this.setState({ phase2Fields: JSON.parse(JSON.stringify(phase2FieldsLost)) })
		} else if (name === 'recurring_type' && option.value === 'birthday') {
			this.setState({ phase2Fields: JSON.parse(JSON.stringify(phase2FieldsBirthday)) })
		} else if (name === 'recurring_type') {
			this.setState({ phase2Fields: JSON.parse(JSON.stringify(phase2Fields)) })
		}
		formHelpers.handleSelectFieldChange(option, name, this.state.currentPhase, this);
	}

	handleMultiSelectClick(name, index, value) {
		formHelpers.handleMultiSelectClick(name, index, value, this.state.currentPhase, this);
	}

  handleCheckboxClick(name, value) {
    formHelpers.handleCheckboxClick(value, name, this.state.currentPhase, this);
  }

  handleFieldBlur(name) {
    formHelpers.handleFieldBlur(name, this.state.currentPhase, this);
  }

  handleSelectClick(field) {
    formHelpers.handleSelectClick(field, this.state.currentPhase, this)
  }

  handleFieldChange(value, name) {
    formHelpers.handleFieldChange(value, name, this.state.currentPhase, this);
  }

  handleFieldFocus(name) {
    formHelpers.handleFieldFocus(name, this.state.currentPhase, this);
  }

	handleModalToggle() {
    const { dispatch, modal } = this.props;
    dispatch(modalActions.modalToggle(!modal.showModal));
	}

	handleBackClick = () => {
		const { activeSection, currentPhase } = this.state;
		phaseHelpers.handleBackClick(activeSection, currentPhase, this);
	}

	handleModalCloseClick() {
		this.setState({
      activeSection: '1',
      currentPhase: 'phase1Fields',
      buttonText: 'next'
		})
		this.handleModalToggle();
	}

  handleNewClick() {
		const { location } = this.props;
    this.setState({
      activeSection: '1',
      currentPhase: 'phase1Fields',
      buttonText: 'Next',
      phase1Fields: JSON.parse(JSON.stringify(phase1Fields)),
			phase2Fields: {},
      phase3Fields: JSON.parse(JSON.stringify(phase3Fields)),
			phase4Fields: JSON.parse(JSON.stringify(phase4Fields)),
			modalFooterMessage: null
    });
    this.handleModalToggle();
  }

	handleEditClick(campaign, isDuplicate=false) {
		const { dispatch, vendor, location } = this.props;
		let updateFieldValue = campaign;
		if (isDuplicate) {
			updateFieldValue = false;
		};
		new Promise((resolve, reject) => {
    	dispatch(modalActions.modalToggle(true));
			dispatch(promotionActions.retrieve(
				vendor.selected.apikey, location.selected.apikey, campaign.promotion_apikey, resolve));
		}).then((res) => {
			let p1Fields = populateForm(campaignHelpers.buildPhase1(campaign), phase1Fields);
			let option = {
				name: p1Fields.recurring_type.displayValue,
				value: p1Fields.recurring_type.value
			}
			let name = 'recurring_type';
			let p2Fields = {};

			if (name === 'recurring_type' && option.value === 'lost-customers') {
				p2Fields = populateForm(campaign, phase2FieldsLost);
			} else if (name === 'recurring_type' && option.value === 'birthday') {
				console.log('CAMPAIGN: ', campaign)
				p2Fields = populateForm(campaign, phase2FieldsBirthday);
			} else if (name === 'recurring_type') {
				p2Fields = populateForm(campaign, phase2Fields);
			}
			formHelpers.handleSelectFieldChange(option, name, this.state.currentPhase, this);

	    this.setState({
	      activeSection: '1',
	      currentPhase: 'phase1Fields',
	      buttonText: 'Next',
	      updateField: updateFieldValue,
				updatePromotion: res,
	      phase1Fields: p1Fields,
				phase2Fields: p2Fields,
	      phase3Fields: populateForm(res, phase3Fields),
				phase4Fields: populateForm(campaign, phase4Fields),
				modalFooterMessage: isDuplicate ? 'You are duplicating this campaign to create a new similar campaign.' : 'You are editing this campaign.'
			})
    })
	}

	handleDuplicateClick = (campaign) => {
		this.handleEditClick(campaign, true);
	}

	handleRowPreCheck(column) {
		return !_.isEmpty(column.recurring_type);
	}

	closeConfirmModal = () => {
		this.setState({
			cancelCampaign: null,
			showConfirmModal: !this.state.showConfirmModal
		});
	}

	handleCancelClick = (campaign) => {
		this.setState({
			cancelCampaign: campaign,
			showConfirmModal: true
		});
	}

	handleCancelCampaign = async () => {
		const { dispatch, location } = this.props;
		const { cancelCampaign } = this.state;
		await dispatch(campaignActions.destroy(location.selected.apikey, location.selected.vendor_apikey, cancelCampaign.apikey));
		this.closeConfirmModal();
	}

  render() {
		const { activeSection, campaign, modalInfo, phase1Fields, phase3Fields } = this.state;

    return (
      <div>
				<Header
					handlePrimaryClick={this.handleNewClick}
          handleLogout={this.props.handleLogoutClick}
					primaryText="NEW AUTO CAMPAIGN"
					title="AUTO CAMPAIGNS" />
				<Table
					handleDuplicateClick={this.handleDuplicateClick}
					handleEditClick={this.handleEditClick}
					handleCancelClick={this.handleCancelClick}
					rowPreCheck={this.handleRowPreCheck}
					rows={this.props.campaign.data}
					columns={campaignTable} />
					{ this.state.showConfirmModal &&
						<ConfirmationModal
							message="Are you sure you want to cancel this campaign? This action cannot be undone."
							onCancel={this.closeConfirmModal}
							onConfirm={this.handleCancelCampaign} />
					}
					{
						this.props.modal.showModal &&
						<Modal
							handleCloseClick={this.handleModalCloseClick}
							title={modalInfo[parseInt(activeSection) - 1].title}
							footerMessage={this.state.modalFooterMessage}>
							<div className="signup__guide">
								<Guide
									header={modalInfo[parseInt(activeSection) - 1].subTitle}
									message={modalInfo[parseInt(activeSection) - 1].content}
									/>
							</div>
							<div className="signup__form">
								<div className="full-wrap">
									<div className="step__wrap">
										<Step text="1" isActive={activeSection === '1' ? true : false} />
										<Step text="2" isActive={activeSection === '2' ? true : false} />
										<Step text="3" isActive={activeSection === '3' ? true : false} />
										<Step text="4" isActive={activeSection === '4' ? true : false} />
									</div>
								</div>
								{
									activeSection === '1' &&
									<div>
										{ formHelpers.buildFields(phase1Fields, this) }
									</div>
								}
								{
									activeSection === '2' &&
									<div>
										{ formHelpers.buildFields(this.state.phase2Fields, this) }
									</div>
								}
								{
									activeSection === '3' &&
									<div>
										{ formHelpers.buildFields(phase3Fields, this) }
									</div>
								}
								{
									activeSection === '4' &&
									<div>
										<h3 className="campaign-text__label">Text Message</h3>
										<div className="campaign-text__message">
											<p className="campaign-text__message-text">{phase3Fields.description.value}</p>
										</div>
										<div className="clear"></div>
										<p className="campaign-text__label campaign-text__label--wide">{phase3Fields.description.value.length} Characters = <span className="campaign-text__blue">1 Message Per Customer</span></p>
										<div className="clear"></div>
										<div>
											<p className="campaign-text__label">Offer Name:</p>
											<p className="campaign-text__value">{this.state.phase3Fields.name.value}</p>
										</div>
										<div>
											<p className="campaign-text__label">Expires:</p>
											<p className="campaign-text__value">{this.state.phase3Fields.days_till_expire.value} days after</p>
										</div>
										{ formHelpers.buildFields(this.state.phase4Fields, this) }
									</div>
								}
								{this.state.activeSection !== '1' &&
									<div className="campaign-text__button-wrap">
										<Button
											allowHover={true}
											text='Back'
											onClick={this.handleBackClick}/>
									</div>
								}
								<Button
									allowHover={true}
									text={this.state.buttonText}
									onClick={this.handleNextClick}/>
							</div>
						</Modal>
					}
      </div>
    );
  }
}

export default withRouter(connect(
  (state) => ({
    campaign: state.campaign,
		location: state.location,
		vendor: state.vendor,
		modal: state.modal,
		promotion: state.promotion
  })
)(AutoCampaigns));



/** WEBPACK FOOTER **
 ** ./src/containers/AutoCampaigns/index.js
 **/